"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./app-error.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import Siren from '../../assets/images/siren.png';

class AppError extends _react.Component {
  constructor(props) {
    super(props);
    const {
      error
    } = props;
    switch (error) {
      case 'path':
        this.state = {
          hasError: true,
          errorText: 'Invalid URL. Please check your URL and try again.'
        };
        break;
      default:
        this.state = {
          hasError: false,
          errorText: ''
        };
        break;
    }
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
      errorText: `${error} ${info.componentStack}`
    });
  }
  render() {
    const {
      hasError,
      errorText
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "error-page"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "error-container"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: null /* Siren */
      }), /*#__PURE__*/_react.default.createElement("h1", null, "Uh-oh!"), /*#__PURE__*/_react.default.createElement("h2", null, "We seem to be having difficulties"), /*#__PURE__*/_react.default.createElement("p", null, errorText)));
    }
    return this.props.children;
  }
}
exports.default = AppError;
//# sourceMappingURL=app-error.js.map